"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ListSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _list = _interopRequireDefault(require("@site/pattern-library-core/list"));
const StyledListSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "StyledListSection",
  class: "pl-s1cpocdh",
  vars: {
    "s1cpocdh-0": [({
      columns
    }) => columns]
  }
});

/**
 * ListSection
 * @module ListSection
 *
 * @param {Object} props React props
 * @param {string} props.invert invert
 * @param {String} props.partial Theme partial
 * @param {string} props.backgroundColor Background color section
 * @param {Object} props.listItem List items
 * @returns {React.ReactElement} ListSection Component
 * @public
 */

function ListSection({
  backgroundColor,
  invert = false,
  partial,
  listItem,
  columns = 3,
  ...headlineProps
}) {
  return /*#__PURE__*/_react.default.createElement(StyledListSection, {
    dataCy: "list-section",
    partial: partial || (invert ? 'dark1' : ''),
    columns: columns,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, /*#__PURE__*/_react.default.createElement(_index.default, headlineProps), /*#__PURE__*/_react.default.createElement(_list.default, (0, _extends2.default)({
    dataCy: "list-items"
  }, listItem)));
}
ListSection.propTypes = {
  backgroundColor: _propTypes.default.shape({
    rgb: _propTypes.default.string,
    intent: _propTypes.default.string
  }),
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  listItem: _propTypes.default.shape(_list.default.propTypes),
  columns: _propTypes.default.number,
  ..._index.default.propTypes
};